export default __webpack_public_path__ + "static/media/illust-mission.ef428227.svg";